module.exports = __webpack_public_path__ + "img/venus3.3be68bf7.png";